import React from 'react';
import { motion } from 'framer-motion';
import { Compass, Zap, Wind } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function WorkshopBenefits() {
  const cards = [{
    icon: Compass,
    title: 'Claritate reală',
    desc: 'Înțelegi ce te blochează cu adevărat. Nu mai cauți răspunsuri în cărți și cursuri fără rezultat. Știi exact ce tipar se repetă în viața ta și de ce. Și știi ce poți face concret.'
  }, {
    icon: Zap,
    title: 'Primul pas practic',
    desc: 'Pleci cu o tehnică pe care o poți aplica imediat. Nu e teorie, nu e informație de adăugat pe stivă. E ceva ce faci chiar în seara în care participi și simți diferența.'
  }, {
    icon: Wind,
    title: 'Liniște interioară',
    desc: 'Prin meditația ghidată din workshop, experimentezi o stare de pace și conectare pe care mulți participanți o descriu ca fiind diferită de orice au simțit până acum.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2169">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2170">
        <SectionHeading title="Ce se schimbă după acest workshop" data-id="element-2171" />

        <div className="grid md:grid-cols-3 gap-8" data-id="element-2172">
          {cards.map((card, index) => {
          const Icon = card.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-2173">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-2174">
                  <Icon className="w-8 h-8" data-id="element-2175" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-2176">
                  {card.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-2177">
                  {card.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}